<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="node.name" label="Name" hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0">
        <AceEditor
          v-model="property.code"
          @init="editorInit"
          lang="javascript"
          theme="textmate"
          width="100%"
          height="320px"
          :options="{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            fontSize: 12,
            highlightActiveLine: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 2,
            showPrintMargin: false,
            showGutter: true
          }"
          :commands="[]"
        />
        <!-- === use for Intellisense ===-->
        <intellisense-component
          :input="property.code"
          :drawFlowItems="drawFlowItems"
          :property="'code'"
          :apiForIntellisense="apiForIntellisense"
          :start="start"
          :eventKey="eventKey"
          @clearSelected="clearSelected"
          @updateInputFromIntellisense="updateInputFromIntellisense"
        />
        <!-- === use for Intellisense ===-->
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" :rows="6" />
  </div>
</template>

<script>
import AceEditor from 'vuejs-ace-editor'

import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    AceEditor,
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  created() {
    this.property = this.node.property
  },
  data() {
    return {
      // === use for Intellisense ให้ keyup keyDown ได้ ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ให้ keyup keyDown ได้ ===
    }
  },
  methods: {
    editorInit() {
      require('brace/ext/language_tools') //language extension prerequsite...
      // require('brace/mode/html')
      require('brace/mode/javascript') //language
      // require('brace/mode/less')
      require('brace/theme/textmate')
      require('brace/snippets/javascript') //snippet
    },
    // === use for Intellisense ===
    updateIntellisense(data) {
      this.node.property.code = '$' + data
    },
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'code') {
        this.property.code = data
      }
    }
    // === use for Intellisense ===
  }
}
</script>

<style scoped lang="scss">
.width70px {
  width: 70px;
}
.margin-left {
  margin-left: 30px !important;
}
</style>
